import React, { useEffect, useState } from 'react'
import classNames from 'classnames';
import Editor from "@monaco-editor/react"
import Axios from 'axios';

import { ReactComponent as BackArrow } from "./../../back-arrow.svg"
import { ReactComponent as DeleteIcon } from "./../../delete-icon.svg"

import "./style.scss";
import { Http } from '../../../../../helpers/axois';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppState, RootState } from '../../../../../stateManager/store';
import { createNewCSSAsset, fetchAllStaticAssetsByFiletype, updateCssAssetUrlById, deleteCssAssetUrlById } from '../../../../../stateManager/store/static-assets/action';
import { useToast } from '../../../../../helpers/commonFunction';
import { Spinner, Modal } from '../../../../../helpers/commonUi';
import style from '../../../../apps/forms/formBuilder/formbuilder.module.sass'
import debounce from 'lodash.debounce';
import { Icon, Spin } from 'antd';

const PAGE_TITLE = "CSS";
const PAGE_SUBTITLE = "Create, update or remove a css"
const SUBMIT_BTN = "Submit"
const SAMPLE_CSS_CODE = "/*Write your css code here*/"
const GLOBAL_CSS_URL = "https://storage.googleapis.com/public-a8-bucket/GlobalStyles/global.css";

interface FormElements extends HTMLFormControlsCollection {
  filename: HTMLInputElement
}
interface FilenameFormElement extends HTMLFormElement {
  readonly elements: FormElements
}

interface DeleteCssFile {
  app_id: string;
  created_at: string;
  filename: string;
  filetype: string;
  id: string;
  org_id: string;
  updated_at: string;
  url: string;
}

export const CssFolder = () => {
  const params: any = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const { SuccessToast, ErrorToast } = useToast()
  const cssFiles = useSelector((state: RootState) => state.staticAssets.css)
  const [selectedFileID, setSelectedFileID] = useState<number | null>(null)
  const [shouldAddNewCss, setShouldAddNewCss] = useState<boolean>(false);
  const [newCSSFileName, setNewCSSFileName] = useState("")
  const [filenameError, setFilenameError] = useState("")
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false)
  const [cssCode, setCssCode] = useState<string | undefined>("/* Write your css code here */")
  const [loading, setLoading] = useState<boolean>(true)
  const [saveLoader, setSaveLoader] = useState<boolean>(false);
  const [deleteVisible, setDeleteVisible] = useState<boolean>(false);
  const [deleteCssFile, setDeleteCssFile] = useState<DeleteCssFile>();
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState<boolean>(false);
  let cancelTokenSource: any = null;
  const ERROR_MESSAGES = {
    DEFAULT_UPDATE_ERROR: (filename: string) => `Error updating ${filename}`,
    FORBIDDEN: "Not Authorized: Please request owner of this organization to provide access",
    INVALID_CSS: "Invalid CSS syntax",
  };
  const orgId = useSelector((state: AppState) => state.org.selectedOrg.id);
  const { selectedOrg } = useSelector((state: AppState) => state.org)
    const loggedInUserId = useSelector((state: any) => {
        return state.user.data.user.id
    })
  const orgPermissions: any = useSelector((state: AppState) => {
    return state.org.orgPermissions
}, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
  const fetchCSSFiles = () => {
    const payload = {
      "appId": params.appId,
      "filetype": "css",
      orgId
    }
    dispatch(fetchAllStaticAssetsByFiletype(payload))
  }

  const debouncedSave = debounce(() => {
    selectedFileID !== -1 && handleCssCodeSubmit();
  }, 1000);

  useEffect(() => {
    fetchCSSFiles();
    document.addEventListener("keydown", (evt: KeyboardEvent) => {
      if (evt.key === "Escape") {
        setNewCSSFileName("");
        setShouldAddNewCss(false);
      }
    })
    setLoading(false);
    return document.removeEventListener("keydown", () => { })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const handleFileSelect = async (file_id: number, url: string) => {
    setShouldAddNewCss(false);
    setLoading(true)
    setSelectedFileID(file_id)
    if (url) {
      const { data } = await Axios.get(url);
      setLoading(false)
      setCssCode(data)
    } else {
      setLoading(false)
      setCssCode(SAMPLE_CSS_CODE)
    }
  }

  const handleEditorChange = (value: string | undefined) => {
    setCssCode(value)
  }

  const scrollSidebarToBottom = () => {
    const scrollHeight = document.getElementsByClassName("css-sidebar")[0].scrollHeight;
    document.getElementsByClassName("css-sidebar")[0].scrollTo(0, scrollHeight);
  }

  const handleAddNewCssFile = () => {
    // Add input for adding new css file
    setShouldAddNewCss(true)

    setTimeout(() => {
      // scroll to bottom of sidebar
      scrollSidebarToBottom()

      document.getElementById("filename")?.focus();
    }, 0)

  }

  const handleNewCSSFilenameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const typedString = e.target.value;
    setNewCSSFileName(typedString);
    setFilenameError("")
    setSubmitButtonDisabled(false);
  }

  const handleFilenameFormSubmit = async (e: React.FormEvent<FilenameFormElement>) => {
    e.preventDefault();
    if((!orgPermissions?.includes("staticAsset.Create") || !orgPermissions.includes('app.View'))&& loggedInUserId!=selectedOrg?.owner ){
      ErrorToast("Not Authorized: Please request owner of this organization to provide access")
     return
    }
    const filename = e.currentTarget.elements.filename.value;
    if (filename.split(".").length > 2 || filename === "") {
      setFilenameError("Only .css files allowed.")
    } else if (filename.split(".").length === 2 && filename.split(".").pop() !== "css") {
      setFilenameError("Only .css files allowed.")
    } else {
      const fileLength = filename.split(".").length === 1;
      try {
        const data: any = await Http.post("/static-asset/create", {
          appId: params.appId,
          filename: fileLength ? filename.concat(".css") : filename,
          filetype: "css",
          "url": "",
          orgId
        }).toPromise()
        if (data.ok) {
          setSelectedFileID(data.asset.id)
          setCssCode(SAMPLE_CSS_CODE)
          setNewCSSFileName("");
          setShouldAddNewCss(false);
          dispatch(createNewCSSAsset(data.asset))
        }
        SuccessToast(`File created successfully`)
      } catch (error) {
        var msg = "File with this name already exist"
        if (error == "Forbidden") {
          msg = "Not Authorized: Please request owner of this organization to provide access"
        }
        console.error(error)
        ErrorToast(msg)
      }
      // scroll sidebar to bottom
      setTimeout(() => {
        scrollSidebarToBottom();
      }, 0)
    }
  }

  const handleCssCodeSubmit = async () => {
    if((!orgPermissions?.includes("staticAsset.Edit") || !orgPermissions.includes('app.View'))&& loggedInUserId!=selectedOrg?.owner ){
      ErrorToast(ERROR_MESSAGES.FORBIDDEN)
     return
    }
    setSaveLoader(true);
    const filename = selectedFileID && cssFiles[selectedFileID]?.filename
    const id = selectedFileID && cssFiles[selectedFileID]?.id;
  
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Cancelled due to new request")
    }
  
    cancelTokenSource = Axios.CancelToken.source();
  
    try {
      const payload = {
        id,
        data: cssCode,
        "appId": params.appId,
        "filetype": "css",
        "orgId": orgId,
        filename
      }
      const res: any = await Http.post(`/static-asset/update-blob`, payload, {
        cancelToken: cancelTokenSource.token
      }).toPromise()
      if (res.ok) {
        dispatch(updateCssAssetUrlById({ id, url: res.url }))
      }
      SuccessToast(`${filename} updated successfully`)
    } catch (error: any) {
      if (Axios.isCancel(error)) {
        return;
      }
  
      var msg = ERROR_MESSAGES.DEFAULT_UPDATE_ERROR(filename);
      if (error === "Forbidden") {
        msg = ERROR_MESSAGES.FORBIDDEN;
      }
      if (error?.errors && error.errors?.message === "Invalid CSS syntax") {
        msg = ERROR_MESSAGES.INVALID_CSS;
      }
      ErrorToast(msg)
      console.error(error)
    } finally {
      setSaveLoader(false);
    }
  }

  const handleBackArrowClick = () => {
    history.goBack();
  }

  const handleCssFileDelete = async (filename: string, id: string) => {
    const endpoint = `/static-asset`;
    try {
      const payload: any = {
        appId: params.appId,
        orgId: orgId,
        id: id,
        filename: filename,
      };
      await Http.put(endpoint, payload).toPromise();
      setSelectedFileID(null)
      dispatch(deleteCssAssetUrlById({ id: id }))
      setSelectedFileID(null);
      SuccessToast('Successfully deleted file');
    } catch (err) {
      console.error(err);
      if (err instanceof Error) {
        const msg = err.message || 'Failed to delete file';
        ErrorToast(msg);
      } else {
        ErrorToast("Failed to delete file");
      }
    }
  }

  useEffect(() => {
    const handleKeyDown = (event: Event) => {
      const e = event as KeyboardEvent;
  
      const isSaveShortcut = (e.ctrlKey || e.metaKey) && e.key === 's';
      
      if (isSaveShortcut) {
        event.preventDefault();
        if (selectedFileID && cssCode) {
          debouncedSave();
        }
      }
    };
  
    if (selectedFileID && cssCode) {
      setSubmitBtnDisabled(false);
    } else {
      setSubmitBtnDisabled(true);
    }

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedFileID, cssCode, cssFiles]);

  const onDeleteCssFile = (deleteCssFile: DeleteCssFile) => {
    setDeleteVisible(false);
    handleCssFileDelete(deleteCssFile?.filename, deleteCssFile?.id);
  }

  const submitButtonnStyles: React.CSSProperties = {
    ...(submitBtnDisabled && { cursor: "not-allowed", backgroundColor: "#C8C9CA" })
  }

  return (
    <div className="css-wrapper">
      <div className="css-header__container">
        <div className="css-header__content-wrapper">
          <div className="header">
            <BackArrow className='backarrow' onClick={handleBackArrowClick} />
            <div className="header-content">
              <div className="header-content--title">{PAGE_TITLE}</div>
              <div className="header-content--subtitle">{PAGE_SUBTITLE}</div>
            </div>
          </div>
          <div className="submit-wrapper">
            <button className="submit-btn" style={submitButtonnStyles} disabled={submitBtnDisabled} onClick={() => debouncedSave()}>{SUBMIT_BTN}</button>
          </div>
        </div>
      </div>
      <hr />
      <div className="css-body__container">
        {saveLoader && <div className='loading-overlay'>
          <div className='loading-wrapper'>
            <Spin indicator={<Icon type="loading" style={{ fontSize: 44, color: '#15808C' }} spin />} />
          </div>
        </div>}
        <div className="css-sidebar">
          <button className={classNames("add-new", { disabled: submitButtonDisabled })} disabled={submitButtonDisabled} onClick={handleAddNewCssFile}>+ Add Custom CSS</button>
          <div className={
            classNames("file ", { active: selectedFileID === -1 })
          } onClick={() => handleFileSelect(-1, GLOBAL_CSS_URL)} title="global.css">global.css</div>
          {cssFiles && Object.values(cssFiles).map((item: any) => (
            <div className={
              classNames("file ", { active: selectedFileID === item.id })
            } key={item.id} onClick={() => handleFileSelect(item.id, item.url)} title={item.filename}>
              <span>{item.filename}</span>
              <button title={"Delete " + item.filename} className='css-delete-btn' 
              onClick={() => {
                setDeleteVisible(true);
                setDeleteCssFile(item);
              } }>
                <DeleteIcon />
              </button>
            </div>
          ))}
          {shouldAddNewCss &&
            <div className="add-new-css__container">
              <form className='form' onSubmit={handleFilenameFormSubmit}>
                <input
                  id="filename"
                  className={classNames('filename', { error: filenameError !== "" })}
                  name="filename"
                  type='text' value={newCSSFileName}
                  onChange={handleNewCSSFilenameChange}
                />
                {filenameError && <p className="filename-error">{filenameError}</p>}
              </form>
            </div>
          }
        </div>
        <div className="css-main--editor">
          {selectedFileID && <Editor
            defaultLanguage="css"
            value={cssCode}
            onChange={handleEditorChange}
            options={{
              readOnly: selectedFileID === -1
            }}
          />}
          {loading && <Spinner />}
        </div>
      </div>
      <Modal
        id="delete_cssFile"
        dataTestId="delete_cssFile"
        title={
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
            <p style={{ marginBottom: 0 }}>{`Delete ${deleteCssFile?.filename}`}</p>
            <div className={style.delete_closeIcon} onClick={() => { setDeleteVisible(false) }}>X</div>
          </div>
        }
        closable={false}
        unmountOnCancel={true}
        visible={deleteVisible}
        onCancel={() => {
          setDeleteVisible(false);
        }}
        footer={{
          OkButtonColor: "shadow-secondary",
          enable: true,
          okText: "DELETE",
          cancelText: "CANCEL",
          onOk: () => {
            deleteCssFile && onDeleteCssFile(deleteCssFile);
          }
        }}
      > <div className={style.modalMsg}>
          Are you sure to delete {deleteCssFile?.filename}?
        </div>
      </Modal>
    </div>
  )
}
